import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { ListColumnDirective } from "@components/list/list-column.directive";
import { ListComponent } from "@components/list/list.component";
import { PageComponent } from "@components/page/page.component";
import { BusyService } from "~app/common/components/busy/busy.service";
import { RaskModalService } from "~app/common/components/modal/rask-modal.service";
import { RaskColumn } from "~app/common/components/table/models/rask-column";
import { MarknadsprislistaTyp } from "~app/common/models/constants";
import { AuthenticationService } from "~app/common/services/authentication/authentication.service";
import { FeatureService } from "~app/common/services/feature.service";
import { IHandelssortimentsgrupp, IMarknadsprislista } from "../models/marknadsprislista-model";
import { MarknadsprislistaViewModel } from "../models/marknadsprislista-table-view-model";
import { IMarknadsomrade, IMarknadsomradeMultiSelector, IResultatomrade } from "../models/verksamhetsomraden-models";
import { MarknadsprislistaService } from "../services/marknadsprislista.service";
import { MarknadsprislistaDialogComponent } from "./marknadsprislista-dialog/marknadsprislista-dialog.component";
import { MarknadsprislistaSearchComponent } from "./marknadsprislista-search/marknadsprislista-search.component";

@Component({
    selector: "rask-marknadsprislista",
    templateUrl: "./marknadsprislista.component.html",
    styleUrls: ["./marknadsprislista.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        PageComponent,
        MarknadsprislistaSearchComponent,
        ListComponent,
        ListColumnDirective
    ]
})
export class MarknadsprislistaComponent implements OnInit {
    handelssortimentGrupper: IHandelssortimentsgrupp[];
    marknadsomrade: IMarknadsomradeMultiSelector[];
    marknadsprislistor: MarknadsprislistaViewModel[] = [];
    prislistor: IMarknadsprislista[];
    tableColumns: RaskColumn[];

    private readonly authenticationService = inject(AuthenticationService);
    private readonly busyService = inject(BusyService);
    private readonly featureService = inject(FeatureService);
    private readonly marknadsprislistaService = inject(MarknadsprislistaService);
    private readonly raskModalService = inject(RaskModalService);

    canEdit = () => this.authenticationService.canEdit();

    create = () => {
        const prislista = {
            id: null,
            violId: null,
            benamning: null,
            vidLeveransGallande: false,
            gallerFrom: null,
            gallerTom: null,
            aktuell: true,
            typ: MarknadsprislistaTyp.Viol3,
            resultatomraden: [] as IResultatomrade[],
            handelssortimentsgrupper: [] as IHandelssortimentsgrupp[]
        } as IMarknadsprislista;

        const data = {
            marknadsomrade: this.marknadsomrade,
            handelssortimentGrupper: this.handelssortimentGrupper,
            prislista: prislista
        };
        this.raskModalService.open("Lägg till marknadsprislista", MarknadsprislistaDialogComponent, "lg", true, data);
    };

    dialogClosed(res: any) {
        if (res === null) {
            return;
        }

        const aktuellPrislista = this.prislistor.find(i => i.id === res.id);
        const index = this.prislistor.indexOf(aktuellPrislista);

        if (aktuellPrislista !== undefined) {
            if (res.deleted === true) {
                this.prislistor.splice(index);
            } else {
                this.prislistor[index] = res;
            }
        } else {
            this.prislistor.push(res);
        }
        this.marknadsprislistor = this.prislistor.map(item => new MarknadsprislistaViewModel(item));
    }

    edit(event: Event, prislista: MarknadsprislistaViewModel) {
        event.preventDefault();
        const aktuellPrislista = this.prislistor.find(i => i.id === prislista.id);
        const data = {
            marknadsomrade: this.marknadsomrade,
            handelssortimentGrupper: this.handelssortimentGrupper,
            prislista: aktuellPrislista
        };
        this.raskModalService.openAsync("Ändra marknadsprislista", MarknadsprislistaDialogComponent, "lg", true, data).subscribe((response) => {
            this.dialogClosed(response);
        });
    }

    ngOnInit() {
        this.pouplateSelectorData();
    }

    onMarknadsprislistor(event: IMarknadsprislista[]) {
        this.prislistor = event;
        this.marknadsprislistor = event.map(item => new MarknadsprislistaViewModel(item));
    }

    pouplateSelectorData() {
        const queryMo = this.marknadsprislistaService.getMarknadsomrade();
        const queryHs = this.marknadsprislistaService.getHandelssortimentsgrupper();

        this.busyService.addWork(queryMo).subscribe((res: any) => {
            this.marknadsomrade = this.mapMarknadsomrade(res);
        });
        this.busyService.addWork(queryHs).subscribe((res: any) => {
            this.handelssortimentGrupper = res;
        });
    }

    private mapMarknadsomrade(mo: IMarknadsomrade[]): IMarknadsomradeMultiSelector[] {
        const marknadsomraden: IMarknadsomradeMultiSelector[] = [];
        mo.forEach((group: IMarknadsomrade) => {
            const groupName = group.namn;
            group.children.forEach((child: IMarknadsomrade) => {
                marknadsomraden.push({
                    id: child.id,
                    namn: child.namn,
                    group: groupName
                });
            });
        });
        return marknadsomraden;
    }
}
